import React, { useEffect, useState } from "react";
import consts from "shared/consts";
import DiscoverSimulationHeader from "src/components/discover-simulation-header";
import TermsModal from "src/components/terms-modal";
import useFeature from "../utils/subscriptionWrapper";
import useIsLoggedIn from "src/utils/use-is-logged-in";
import store from "src/store";
import DiscoverSimulationFilterTabs from "src/components/discover-simulation-filter-tabs";
import Progress from "src/components/progress";
import SimulationCard from "src/components/simulation-card";
import LoadingPage from "./loading-page";
import PrintSimulations from "./print-simulations";

const HOME_URL = window["config"].HOME_URL ?? "https://blockchain.ey.com";

function qs() {
  return require('qs').parse(location.search.slice(1))
}

export default function Simulations() {
  let accepted = true;

  if (window["config"].SKIP_SIMULATION_LIBRARY_TERMS !== true) {
    accepted = localStorage.SKIP_SIMULATION_LIBRARY_TERMS === 'true';
  }

  const { checking, userInfo, isLoggedIn } = useIsLoggedIn();

  const REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS = useFeature(consts.FEATURE_FLAG_REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS);

  const [isTermsAccepted, setTermsAccepted] = useState(true);

  const termsAccepted = () => {
    localStorage.setItem('SKIP_SIMULATION_LIBRARY_TERMS', 'true');
    setTermsAccepted(true);
  }

  const redirectToProductPage = () => {
    window.location.href = HOME_URL + '/products/review-tool';
  }

  store.useRerenderIfChange(() => [
    store.simulations,
    store.simulationFilter,
    store.duplicating,
    store.simulationMetadataLoading,
    qs().print
  ]);

  if (store.duplicating) {
    return <LoadingPage />
  }

  if (qs().print == 'yes') {
    return <PrintSimulations />
  }

  return (
    <>
      {isTermsAccepted && (
        <div css={`
        padding:35px;
        background:#F6F6FA;
        min-height:100vh;
      `}>
          <DiscoverSimulationHeader
            public={!REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS}
            isLoggedIn={isLoggedIn}
          />
          <hr css={`
            margin-top:15px;
            border: 1px solid #EAEAF2;
            `}
          />
          {
            (!store.simulationMetadataLoading && qs().review_id) ?
              <div css={`
              margin-top:25px;
              margin-bottom:25px;
            `}>
                <DiscoverSimulationFilterTabs
                  isLoggedIn={isLoggedIn}
                  userInfo = {userInfo}
                />
              </div> : null
          }
          <div css={`
          margin-bottom:100px;
          clear:both;
        `}>
            {store.simulationMetadataLoading && <Progress />}
            {!store.simulationMetadataLoading && <div>
              {
                store.simulations.length ? store.simulations.map((item, index) => {
                  return <SimulationCard key={index} simulation={item} isLoggedIn={isLoggedIn} />
                }
                ) : null
              }
              </div>}
          </div>
        </div>
      )}
      {!isTermsAccepted && (
        <TermsModal
          open={true}
          onClose={redirectToProductPage}
          onAccepted={() => termsAccepted()} />
      )}
    </>
  )
}